import React from 'react'
import ConnectedComponent from '../../../shared/connecter/ConnectedComponent'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import Podium from './PodiumComponent'


function compare(a, b) {
    const da = a.total;
    const db = b.total;
    if (da < db) return -1;
    if (da > db) return 1;
    return 0;
}


export default class EndGameComponent extends ConnectedComponent {
    constructor() {
        super();
        this.subscribe('game')
        this.state = {
            modal: true
        }
    }

    handleOpen = () => {
        this.setState({modal: true});
    }

    handleClose = () => {
        this.setState({modal: false});
    }

    render() {

        if (this.store.game.get('status') !== 'ended') return null;


        const players = this.store.players.toJSON().map(player => {
            const score = player.scoreBoard.reduce((prev, v)=> {
                return prev + v.value
            }, 0)
            const numberScore = player.scoreBoard.reduce((prev, v)=> {
                return prev + (/^nums/.test(v.id) ? v.value : 0 )
            }, 0)
            return {...player, total: score + (numberScore >= 60 ? 35 : 0)}
        }).sort(compare).reverse()

        const actions = [
            <FlatButton
                label="Fermer"
                keyboardFocused={true}
                onTouchTap={this.handleClose}
            />,
        ];


        return (<div>
            <Dialog
                title=""
                actions={actions}
                modal={true}
                open={this.state.modal}
                onRequestClose={this.props.handleClose}
            >
                <Podium players={players}/>
            </Dialog>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/game/leaderboards/components/EndGameComponent.jsx